export const SOCKET_ONOPEN = '✅ Socket connected!'
export const SOCKET_ONCLOSE = '❌ Socket disconnected!'
export const SOCKET_ONERROR = '❌ Socket Error!!!'
export const SOCKET_ONMESSAGE = 'Websocket message received'
export const SOCKET_RECONNECT = 'Websocket reconnected'
export const SOCKET_RECONNECT_ERROR = 'Websocket is having issues reconnecting..'

export const SET_MESSAGES = 'set_messages';

export const MESSAGE_ID = 'MESSAGE_ID';
export const QR_CODE = 'QR_CODE';
export const PIN_CODE = 'PIN_CODE';
export const LOGIN_SAVE = 'LOGIN_SAVE';
export const REDIRECT_URI = 'REDIRECT_URI';
export const RETURN_TYPE = 'RETURN_TYPE';
export const COUNTRY_CODE = 'COUNTRY_CODE';

export const SVC_LIST = 'SVC_LIST'
export const LANGUAGE = 'LANGUAGE'
export const COLOR_THEME = 'COLOR_THEME'
export const DISPLAY = 'DISPLAY'
export const CROSS_LOGIN = 'CROSS_LOGIN'
export const EXCEPT_NEW = 'EXCEPT_NEW'
export const TERMS_NAME = 'TERMS_NAME'
export const THIRD_PARTY_SERVICE_NAME = 'THIRD_PARTY_SERVICE_NAME'
export const SHOW_LOGIN_TYPE = 'SHOW_LOGIN_TYPE'
export const RESPONSE_TYPE = 'RESPONSE_TYPE'
export const CLIENT_ID = 'CLIENT_ID'
export const STATE = 'STATE'

export const IDPW = 'IDPW'

export const QR_DT = 'QR_DT'
export const QR_TC = 'QR_TC'
export const QR_RP = 'QR_RP'
export const QR_TM = 'QR_TM'
export const QR_SN = 'QR_SN'
export const QR_SM = 'QR_SM'
